module.exports={key:"6gForf4B2O7MTdYecsUK4GlRiLJGHU3r",host:"https://app.ticketmaster.com/discovery/v2/events.json",pagination:{elements:7}};